export default __webpack_public_path__ + "static/media/IMG5.b6ad1892.jpg";